import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AccountDetailPage from './pages/AccountDetailPage';
import SettingsPage from './pages/SettingsPage';
import SplitTemplatesPage from './pages/SplitTemplatesPage';
import AutopaymentsPage from './pages/AutopaymentsPage';
import BelieveItInPage from './pages/BelieveItInPage';
import AnalyticsOverviewPage from './pages/AnalyticsOverviewPage';
import TaxHelperPage from './pages/TaxHelperPage';
import AffordabilityExplorerPage from './pages/AffordabilityExplorerPage';
import CompliancePage from './pages/CompliancePage';
import LargePurchasePage from './pages/LargePurchasePage';

import AccountAnalyticsPage from './pages/AccountAnalyticsPage';
import CategoryInsightsPage from './pages/CategoryInsightsPage';
import Navbar from './components/Navbar';
import GlobalAgentChatLauncher from './components/ai/GlobalAgentChatLauncher';
import AllocationReviewPage from './pages/AllocationReviewPage';
import DailyTallyPage from './pages/DailyTallyPage';
import IntakeReminder from './components/intake/IntakeReminder';

const useTimezoneDetection = () => {
  useEffect(() => {
    const updateTimezone = async () => {
      const currentTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const savedTz = localStorage.getItem('userTimezone');
      
      if (currentTz !== savedTz && localStorage.getItem('access_token')) {
        try {
          await fetch('/api/auth/update-timezone', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('access_token')}`
            },
            body: JSON.stringify({ timezone: currentTz }),
          });
          localStorage.setItem('userTimezone', currentTz);
        } catch (error) {
          console.error('Failed to update timezone:', error);
        }
      }
    };
    
    updateTimezone();
  }, []);
};

function App() {
  useTimezoneDetection();
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<LoginPage />} /> {/* Default route */}
        <Route
          path="/*"
          element={
            <>
              <Navbar />
              <IntakeReminder />
              <Routes>
                <Route path="/daily-tally" element={<DailyTallyPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/accounts/:id" element={<AccountDetailPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/split-templates" element={<SplitTemplatesPage />} />
                <Route path="/autopayments" element={<AutopaymentsPage />} />
                <Route path="/believe-it-in" element={<BelieveItInPage />} />
                <Route path="/tax-helper" element={<TaxHelperPage />} />
                <Route path="/affordability" element={<AffordabilityExplorerPage />} />
                <Route path="/compliance" element={<CompliancePage />} />
                <Route path="/large-purchase" element={<LargePurchasePage />} />
                <Route path="/allocation-review" element={<AllocationReviewPage />} />
                <Route path="/analytics" element={<AnalyticsOverviewPage />} />
                <Route path="/analytics/categories" element={<CategoryInsightsPage />} />
                <Route path="/analytics/accounts" element={<AccountAnalyticsPage />} />
              </Routes>
              <GlobalAgentChatLauncher />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
